import { appstr } from "../utils/appstr";
import { enumCalcCode, enumExcelExportScope, enumObjectTypes } from "../constants";
import { GetFieldDefBy } from "../utils/GetFieldDefBy";
import { GetFieldLabel } from "../utils/GetFieldLabel";
import { GetObjecDBLevel } from "../utils/GetObjecDBLevel";
import { QExcelRow } from "./QExcelRow";

export class QExcelOut {
  constructor() {
    this.fObjDB = null;
    this.fCurOrg = null;
    this.fFilename = null;

    this.fRowList = null;
    this.fFieldDefs = null;
    this.fExportScope = enumExcelExportScope.entirechart;
    this.fChainOfCommand = false;
    this.fSystemFields = true;
  }

  InitJSON(objDB, curOrg, filename, exportWhat, fieldDefs, chainOfCommand, systemFields) {
    this.fExportScope = exportWhat;
    this.fChainOfCommand = chainOfCommand;
    this.fSystemFields = systemFields;
    this.fFieldDefs = fieldDefs;

    this.fObjDB = objDB;
    this.fCurOrg = curOrg;
    this.fFilename = filename;
    this.fManualAddKeys = false;

    this.fRowList = [];
    this.AddHeaders();
    this.AddData();
  }

  AddHeaderRow() {
    var objDB = this.fObjDB;
    var boxClass = objDB.GetClassByName("Box");

    var aRow = new QExcelRow();
    aRow.Init();
    var exScope = this.fExportScope;
    var includeSys = this.fSystemFields;
    var includeSuperLookup = true;
    var useFieldList = false;
    var m = this.fFieldDefs.length;
    var includeChain = this.fChainOfCommand;

    switch (exScope) {
      case enumExcelExportScope.redeployed:
        break;
      case enumExcelExportScope.entirechart:
        includeSuperLookup = false;
        useFieldList = m > 0;
        break;
    }

    if (useFieldList) {
      for (var i = 0; i < m; i++) {
        var f = this.fFieldDefs[i];
        var displayName = GetFieldLabel(f);
        //var displayName = f.GetFieldDisplayName();
        aRow.AddCell(displayName);
      }
    } else {
      var exportStr = "-" + appstr("Export");
      var n = boxClass.GetFieldCount();

      // No PersonID/Supervisor so add it manually
      var superIDDef = boxClass.GetFieldDefByID("SupervisorID");
      if (superIDDef == null) {
        this.fManualAddKeys = true;
        aRow.AddCell("PersonID");
        aRow.AddCell("SupervisorID");
      }
      var manualAdd = this.fManualAddKeys;

      for (var i = 0; i < n; i++) {
        var f = boxClass.GetIndexFieldDef(i);
        if (f.GetCalcCode() == null) {
          var fieldID = f.GetFieldID();
          var includeField = true;
          switch (fieldID) {
            case "AlsoReportsTo":
            case "Also^Reports^To":
            case "isAux":
            case "ID":
              includeField = false;
              break;
            case "Orphan":
            case "TopOfSubChart":
              includeField = includeSys;
              break;
            case "Locked":
            case "Persist":
              includeField = includeSys;
              break;
          }

          if (includeField) {
            this.fFieldDefs.push(f);
            var displayName = GetFieldLabel(f);
            //					var displayName = f.GetFieldDisplayName();
            aRow.AddCell(displayName);
          }
        }
      }

      if (!manualAdd) {
        var superID = boxClass.GetFieldDefByID("NewSuperID");
        if (includeSuperLookup) {
          this.fFieldDefs.push(superID);
          var superName = superID.GetFieldDisplayName() + exportStr;
          aRow.AddCell(superName);
        }
      }

      if (includeChain) {
        aRow.AddCell(appstr("chainofcommand"));
        aRow.AddCell(appstr("Level"));
      }
    }

    this.fRowList.push(aRow);
  }

  AddCell(obj, fieldDef, aRow) {
    var v = obj.GetFieldValue(fieldDef);
    if (v == null) v = "";
    aRow.AddCell(v);
  }

  AddDataRows() {
    var objDB = this.fObjDB;
    var boxClass = objDB.GetClassByName("Box");
    var objMgr = boxClass.GetObjMgr();
    var n = objMgr.GetObjectCount();

    var IDDef = null;
    var superIDDef = null;
    if (this.fManualAddKeys) {
      IDDef = boxClass.GetFieldDefByID("ID");
      superIDDef = boxClass.GetFieldDefByID("NewSuperID");
    }

    for (var i = 0; i < n; i++) {
      var aRow = new QExcelRow();
      aRow.Init();

      var anObject = objMgr.GetIndexObject(i);
      var m = this.fFieldDefs.length;

      if (anObject.IsPersistent()) {
        var proceed = true;
        var isOrphan = anObject.IsOrphan();
        var overrideSuper = false;
        var overrideSuperVal = null;
        var addChainOfCmd = this.fChainOfCommand;

        switch (this.fExportScope) {
          case enumExcelExportScope.orphanrecords:
            proceed = isOrphan;
            break;
          case enumExcelExportScope.toporphans:
            proceed = isOrphan && anObject.IsRoot();
            break;
          case enumExcelExportScope.currentbranch:
          case enumExcelExportScope.currentpage:
            proceed = anObject["objfilter"] == "include"; // || isOrphan;
            break;
          case enumExcelExportScope.redeployed:
            var newSuper = anObject.NewSupervisorID();
            if (newSuper == null) newSuper = "";
            var origSuper = anObject.GetObjectSupervisorID();
            if (origSuper == null) origSuper = "";
            proceed = newSuper != origSuper;
            break;
          case enumExcelExportScope.entirechart:
            overrideSuperVal = anObject.NewSupervisorID();
            overrideSuper = true;
            break;
        }

        if (proceed) {
          if (IDDef) this.AddCell(anObject, IDDef, aRow);
          if (superIDDef) this.AddCell(anObject, superIDDef, aRow);

          var v;
          for (var j = 0; j < m; j++) {
            var auxRecord = false;
            var fieldDef = this.fFieldDefs[j];
            var fieldID = fieldDef.GetFieldID();

            if (overrideSuper && fieldID == "SupervisorID") v = overrideSuperVal;
            else v = anObject.GetFieldValue(fieldDef);
            if (v == null) v = "";
            if (fieldID == "PersonID" && v.toString().indexOf("aux") > 0) {
              auxRecord = true;
              break;
            }
            aRow.AddCell(v);
          }

          if (addChainOfCmd) {
            v = anObject.GetChainOfCommand();
            aRow.AddCell(v);
            v = GetObjecDBLevel(anObject);
            aRow.AddCell(v);
          }
          if (!auxRecord) this.fRowList.push(aRow);
        }
      }
    }
  }

  AddHeaders() {
    var objDB = this.fObjDB;
    var boxClass = objDB.GetClassByName("Box");

    var exScope = this.fExportScope;
    var includeSys = this.fSystemFields;
    var includeSuperLookup = true;
    var useFieldList = false;
    var m = this.fFieldDefs.length;
    var includeFormulas = false;
    var includeChain = this.fChainOfCommand;
    this.fHeaders = [];
    this.fHeaderLabels = [];
    switch (exScope) {
      case enumExcelExportScope.redeployed:
        break;
      case enumExcelExportScope.currentpage:
      case enumExcelExportScope.currentbranch:
      case enumExcelExportScope.entirechart:
        includeSuperLookup = false;
        useFieldList = m > 0;
        break;
      case enumExcelExportScope.entirechartplus:
        includeSuperLookup = false;
        includeFormulas = true;
        break;
    }

    if (useFieldList) {
      for (var i = 0; i < m; i++) {
        var f = this.fFieldDefs[i];
        var displayName = GetFieldLabel(f);
        this.fHeaders.push(f.GetFieldName());
        this.fHeaderLabels.push(displayName);
      }
    } else {
      var exportStr = "-" + appstr("Export");
      var n = boxClass.GetFieldCount();

      var manualAdd = this.fManualAddKeys;
      for (var i = 0; i < n; i++) {
        var f = boxClass.GetIndexFieldDef(i);
        if (f.GetCalcCode() == null || f.GetCalcCode() === enumCalcCode.static) {
          var fieldID = f.GetFieldID();
          var includeField = true;
          switch (fieldID) {
            case "AlsoReportsTo":
            case "Also^Reports^To":
            case "isAux":
            case "ID":
            case "scFlag":
              includeField = false;
              break;
            case "Orphan":
            case "TopOfSubChart":
            case "Locked":
            case "Persist":
              includeField = includeSys;
              break;
          }

          if (includeField) {
            this.fFieldDefs.push(f);
            var displayName = GetFieldLabel(f);
            this.fHeaders.push(f.GetFieldName());
            this.fHeaderLabels.push(displayName);
          }
        } else if (f.GetCalcCode() != null && includeFormulas) {
          this.fFieldDefs.push(f);
          var displayName = GetFieldLabel(f);
          this.fHeaders.push(f.GetFieldName());
          this.fHeaderLabels.push(displayName);
        }
      }

      if (!manualAdd) {
        var superID = boxClass.GetFieldDefByID("NewSuperID");
        if (includeSuperLookup) {
          this.fFieldDefs.push(superID);
          var superName = superID.GetFieldDisplayName() + exportStr;
          this.fHeaders.push(superID.GetFieldName());
          this.fHeaderLabels.push(superName);
        }
      }

      if (includeChain) {
        this.fHeaders.push(appstr("chainofcommand"));
        this.fHeaderLabels.push(appstr("chainofcommand"));
        this.fHeaders.push(appstr("Level"));
        this.fHeaderLabels.push(appstr("Level"));
      }
    }
  }

  AddData() {
    var objDB = this.fObjDB;
    var boxClass = objDB.GetClassByName("Box");
    var objMgr = boxClass.GetObjMgr();
    var n = objMgr.GetObjectCount();

    var IDDef = null;
    var superIDDef = null;
    if (this.fManualAddKeys) {
      IDDef = boxClass.GetFieldDefByID("ID");
      superIDDef = boxClass.GetFieldDefByID("NewSuperID");
    }

    var objectList = boxClass.GetObjectList();
    var exportableObjects = objectList.filter(obj => obj.IsPersistent() && !obj.IsDeleted());
    var isPositionDoc = this.fObjDB.GetDocRef()?.IsPositionDocument() === true;

    for (var anObject of exportableObjects) {
      var aRow = {};

      var m = this.fFieldDefs.length;
      var proceed = true;
      var isOrphan = anObject.IsOrphan();
      var overrideSuper = false;
      var overrideSuperVal = null;
      var addChainOfCmd = this.fChainOfCommand;

      switch (this.fExportScope) {
        case enumExcelExportScope.orphanrecords:
          proceed = isOrphan;
          break;
        case enumExcelExportScope.toporphans:
          proceed = isOrphan && anObject.IsRoot();
          break;
        case enumExcelExportScope.currentbranch:
        case enumExcelExportScope.currentpage:
          proceed = anObject["objfilter"] == "include"; // || isOrphan;
          break;
        case enumExcelExportScope.redeployed:
          var newSuper = anObject.NewSupervisorID();
          if (newSuper == null) newSuper = "";
          var origSuper = anObject.GetObjectSupervisorID();
          if (origSuper == null) origSuper = "";
          proceed = newSuper != origSuper;
          break;
        case enumExcelExportScope.entirechart:
          overrideSuperVal = anObject.NewSupervisorID();
          overrideSuper = true;
          break;
      }

      if (proceed) {
        if (IDDef) aRow[IDDef.GetFieldName()] = anObject.GetFieldValue(IDDef);
        if (superIDDef) aRow[superIDDef.GetFieldName()] = anObject.GetFieldValue(superIDDef);

        var v;
        for (var j = 0; j < m; j++) {
          var auxRecord = false;
          var fieldDef = this.fFieldDefs[j];
          var fieldID = fieldDef.GetFieldID();

          if (overrideSuper && fieldID == "SupervisorID") v = overrideSuperVal;
          else v = anObject.GetFieldValue(fieldDef);
          if (v == null) v = "";
          if (fieldID === "objType" && !isPositionDoc && v === "") v = enumObjectTypes.person;
          if (fieldID == "PersonID" && v.toString().indexOf("aux") > 0) {
            auxRecord = true;
            break;
          }
          if (fieldDef.IsList() && Array.isArray(v)) {
            aRow[fieldDef.GetFieldName()] = v.join(", ");
          } else {
            aRow[fieldDef.GetFieldName()] = v;
          }
        }

        if (addChainOfCmd) {
          v = anObject.GetChainOfCommand();
          aRow[appstr("chainofcommand")] = v;
          v = GetObjecDBLevel(anObject);
          aRow[appstr("Level")] = v;
        }
        if (!auxRecord) this.fRowList.push(aRow);
      }
    }
  }
}
